<template>
  <div class="user-deal-container">
    <h1 class="title">用户须知</h1>

    <dl class="deal-section">
      <dd class="deal-item">1、请用户在注册和使用本平台功能前认真阅读<router-link to="/userdeal.html">《Hello单身部落用户协议》</router-link>，同意并注册则表示该用户已悉知协议细则，本人同意且需遵守各项协议的内容条款。</dd>
      <dd class="deal-item">2、本平台的信息资料皆来源于用户本身，平台只是做信息的展示和功能的实现，用户需对自己提供的资料真实性负全部责任，如有虚假信息欺诈等违规行为，本平台有权追责。</dd>
      <dd class="deal-item">3、用户上传证件资料（如身份证、营业执照、工作证、劳动合同等）委托本平台做实名审核，审核通过后则成为平台的实名用户。本平台只做资料核对和形式上的审查，真实度有限，仅作为实名参考，并不承担任何担保。</dd>
      <dd class="deal-item">4、请大家在使用本平台交友过程中保护好自己，对自身的人身和财产安全负全部责任，做好安全防范措施，避免财产往来和过密接触。因此而产生的纠纷违法等行为，平台本身不负任何法律责任。</dd>
      <dd class="deal-item">5、如遇到虚假信息、欺骗行为、不良目的或人品素质等有问题的用户，欢迎向本平台投诉并举证。平台将视具体情况作出相应的处理（如限制该用户权限、账号封禁、全平台公告等方式），以保障他人的权益和安全。</dd>
    </dl>
  </div>
</template>

<script>
export default {
  name: 'agreement'
}
</script>

<style lang="scss">
.user-deal-container {
  padding: 30px 40px 80px;
  .title {
    font-size: 32px;
    line-height: 44px;
    font-weight: bold;
    text-align: center;
  }
  .deal-section {
    margin-top: 30px;
    font-size: 22px;
    line-height: 44px;
    text-align: left;
  }
  .deal-item {
    color: #696969;
  }
}
</style>
